import { QueryClient } from '@tanstack/react-query';

/**
 * The one query client, importable outside React.
 *
 * A resource definition is a plain object — no hooks — so an action declared on
 * one has no other way to invalidate what it just changed. It lives here rather
 * than in `main.tsx` so importing it does not drag the whole app in.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The API is the source of truth; refetching on focus is noise in a tool
      // people keep open all day.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});
